export default __webpack_public_path__ + "static/media/product-1.559cc321.jpg";